// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xRaN","colMin":"styles_colMin__2Otxo"};